import {countryArr} from "@/assets/js/country";
import {languageArr} from "@/assets/js/language";
import {info_view,organList} from "@/api/ab_signup/api";
import {storageData} from "@/assets/js/storage";
const HOST = process.env.VUE_APP_URL;
export default {
  data() {
    const gender = [
      {
        key: "男",
        val: "Male"
      },
      {
        key: "女",
        val: "Female"
      },
    ];
    return {
      gender,
      countryArr,
      languageArr,
      stuInfo: {},
      organList:[],
      signId: this.$route.query.signId,
    };
  },
  created() {
    this.getInfo();
    this.getOrganList();
  },
  methods: {
    getInfo() {
      info_view({enroll_uuid: this.signId })
        .then(({data}) => {
          if (Number(data.status) === 0) {
            // console.log(data);
            let {language_list, academic_data, experience_data, playing_data, studentSingnInfo,enrollMap} = data.result;
            this.$set(this.vitaForm,"enroll_name",enrollMap.enroll_name);
            // 护照头像，身份证正反面
            studentSingnInfo.profile_picture && (this.photo = HOST + studentSingnInfo.profile_picture);
            const userInfo = storageData.getUserInfo();
            this.type=userInfo.member_type;
            if (studentSingnInfo.profile_picture){
              if (userInfo.member_type==="expireStudent"||userInfo.member_type==="registration"){
                this.not_change=true;
              }
            }
            if (studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
              this.$set(this.vitaForm,'family_name_spell',studentSingnInfo.family_name_spell);
              this.switch_pinyin=true;
            }
            studentSingnInfo.id_card_photo_front && (this.cardFront = HOST + studentSingnInfo.id_card_photo_front);
            studentSingnInfo.id_card_photo_verso && (this.cardBack = HOST + studentSingnInfo.id_card_photo_verso);
            // 外语
            language_list.length && this.$set(this.vitaForm, "language_row", language_list);
            // 公用临时数组
            let tempArr = [];
            // 教育经历
            let academic_qualification = [];
            if (academic_data.length) {
              academic_qualification = academic_data.map((item) => {
                if(item.academic_start_date && item.academic_end_date) {
                  tempArr = [new Date(item.academic_start_date), new Date(item.academic_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }
            // 执教经历
            let coaching_Experience = [];
            if (experience_data.length) {
              coaching_Experience = experience_data.map((item) => {
                if(item.coach_start_date && item.coach_end_date) {
                  tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }
            // 运动经历
            let playing_experience = [];
            if (playing_data.length) {
              playing_experience = playing_data.map((item) => {
                if(item.play_start_date && item.play_end_date) {
                  tempArr = [new Date(item.play_start_date), new Date(item.play_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }
            let mixinObj = {
              academic_qualification,
              // coaching_qualification,
              coaching_Experience,
              playing_experience
            };
            let {entries} = Object;
            for (let [key, value] of entries(mixinObj)) {
              if (value.length === 0) {
                delete mixinObj[key];
              }
            }
            // 学员信息
            const birthDay = studentSingnInfo.id_number.length == 18
              ? studentSingnInfo.id_number.substr(6, 4) + "-" + studentSingnInfo.id_number.substr(10, 2) + "-" + studentSingnInfo.id_number.substr(12, 2)
              : "--";
            this.noEdit = {
              gender: studentSingnInfo.gender,
              phone: studentSingnInfo.mobile_phone,
              idNum: studentSingnInfo.id_number,
              birthDay,
            };
            this.vitaForm = {
              ...this.vitaForm,
              ...studentSingnInfo,
              ...mixinObj
            };
            this.$set(this.vitaForm, "org_id", (enrollMap.org_id === 0 || enrollMap.org_id == null) ? "" : enrollMap.org_id);
            this.isLoading = false;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 获取所有的足协列表
    getOrganList(){
      organList({}).then(
        ({ data: { result, status } }) => {
          if (status === 0) {
            this.organList = result.list;
          }
        }
      );
    }
  }
}
